export default {
    path: '/appCapabilitiesAddPush',
    auth: false,
    preload: false,
    isStatic: true,
    key: 'appCapabilitiesAddPush',
    layout: 'inner', // outer 一级菜单 inner 二级菜单
    component: () => import('./index')
  };
  